import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { getAuth, signInWithEmailAndPassword, sendPasswordResetEmail } from 'firebase/auth';
import './Signin.css';
import logo from './ap-logo-4.png';
import { app } from './firebase';

const SignIn = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const auth = getAuth(app);

  const handleEmailChange = (e) => setEmail(e.target.value);
  const handlePasswordChange = (e) => setPassword(e.target.value);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate('/home');
    } catch (error) {
      setError('Failed to sign in. Please check your email and password.');
    }
  };

  const handleForgotPassword = async () => {
    if (!email) {
      setError('Please enter your email address to reset your password.');
      return;
    }
    try {
      await sendPasswordResetEmail(auth, email);
      setError('Password reset email sent. Check your inbox.');
    } catch (error) {
      setError('Failed to send password reset email. Please try again.');
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-left">
          <p className="eyebrow">Client Portal</p>
          <h1>Meals management made simple.</h1>
          <p className="lead">Sign in to place orders, update delivery details, and keep your venues on track.</p>
          <div className="pill-group">
            <span className="pill">Secure access</span>
            <span className="pill">Real-time updates</span>
            <span className="pill">UK operations</span>
          </div>
        </div>

        <div className="auth-right">
          <div className="logo-row">
            <img src={logo} alt="Akshaya Patra Logo" className="logo" />
            <span className="brand">Akshaya Patra UK</span>
          </div>
          <h2 className="login-header">Sign in</h2>
          <form className="login-form" onSubmit={handleSubmit}>
            <label>Email</label>
            <input
              type="email"
              value={email}
              onChange={handleEmailChange}
              placeholder="you@example.com"
              required
              aria-label="Email Address"
            />
            <label>Password</label>
            <input
              type="password"
              value={password}
              onChange={handlePasswordChange}
              placeholder="Enter your password"
              required
              aria-label="Password"
            />
            <div className="form-footer">
              <button type="submit" className="signin-button">Sign In</button>
              <button
                type="button"
                onClick={handleForgotPassword}
                className="forgot-password"
                aria-label="Forgot Password"
              >
                Forgot password?
              </button>
            </div>
          </form>
          {error && <p className="error-message">{error}</p>}
          <div className="signup-cta">
            <span>New to the portal?</span>
            <Link to="/signup" className="signup-link">Create an account</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignIn;
